import './ChemelexUiToggle.scss';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import FormGroup from '@mui/material/FormGroup';
import Switch from '@mui/material/Switch';
import { Map } from 'immutable';

import { updateUser } from 'src/module/user/action';
import {
  CHEMELEX_UI_PREFERENCE,
  hasChemelexUiFeature,
  getUseChemelexUiPreference
} from 'src/module/authentication/chemelexUi.selector';
import { useTranslation } from 'src/i18n';

/*
 * Per-user opt-out from the redesigned UI (ADR-00003 SD3).
 */
export default function ChemelexUiToggle () {
  const dispatch = useDispatch();
  const hasFeature = useSelector(hasChemelexUiFeature);
  const useChemelexUi = useSelector(getUseChemelexUiPreference);
  const { t } = useTranslation();

  // Facilities without the feature never see the option.
  if (!hasFeature) {
    return null;
  }

  const handleChange = (e) => {
    dispatch(updateUser(null, Map({ [CHEMELEX_UI_PREFERENCE]: e.target.checked })));
  };

  return (
    <div className='chemelex-ui-toggle'>
      <h4>{t('profile.updatedView')}</h4>
      <FormGroup>
        <Switch
          checked={useChemelexUi !== false}
          onChange={handleChange}
          color='primary'
          title={t('profile.updatedViewDescription')}
          inputProps={{ 'aria-label': t('profile.updatedView') }}
        />
      </FormGroup>
    </div>
  );
}
